export default __webpack_public_path__ + "static/media/studio-5.6b052d75.jpg";